// extracted by mini-css-extract-plugin
module.exports = {"agentShowsProgressColor":"#1a72e8","agentObjectsProgressColor":"#f6ba20"};